// Extra content for the redesigned Placements page — the sections that were
// added on top of the existing data (industry-collab gallery, Project Week,
// Project Street, Certifications + Claude-Certified Architects, Placement Team).
// All images are the WebP versions compressed for the web. Items marked
// `// EDIT` are placeholders to replace with the real values.
const DIR = "/images/placements-page";

/* ---- Industry Collaboration gallery (students in the field) ----
   Grouped by industry partner. Each partner shows a 1-big + 4-small swap
   gallery; the partner rail (top-left) switches between them. */
export const industryCollab = {
  eyebrow: "Beyond the classroom",
  title: "Industry Collaboration",
  text:
    "Our students don't just learn about industry — they live it. From ServiceNow University to on-site corporate sessions, here's NCET in the field, working shoulder-to-shoulder with the companies that hire them.",
  industries: [
    {
      key: "servicenow",
      name: "ServiceNow",
      items: [
        { src: `${DIR}/Industry_Collab/0002.webp`, tag: "ServiceNow University", caption: "At the ServiceNow ecosystem & job-demand session" },
        { src: `${DIR}/Industry_Collab/0003.webp`, tag: "Corporate Connect", caption: "Hands-on with industry mentors" },
        { src: `${DIR}/Industry_Collab/0007.webp`, tag: "On-Site Learning", caption: "Inside our partner organizations" },
        { src: `${DIR}/Industry_Collab/0010.webp`, tag: "Industry Immersion", caption: "Real teams, real platforms" },
        { src: `${DIR}/Industry_Collab/0011.webp`, tag: "Tech Summit", caption: "Networking with recruiters & leaders" },
      ],
    },
    {
      key: "o9",
      name: "o9 Solutions",
      items: [
        { src: `${DIR}/Industry_Collab/o9_0.webp`, tag: "Corporate Connect", caption: "With o9's leadership and mentors" },
        { src: `${DIR}/Industry_Collab/o9_2.webp`, tag: "o9 Solutions", caption: "NCET students at the o9 Solutions campus" },
        { src: `${DIR}/Industry_Collab/o9_1.webp`, tag: "Industry Visit", caption: "Exploring o9's AI-driven platform" },
        { src: `${DIR}/Industry_Collab/o9_3.webp`, tag: "On-Site Learning", caption: "Inside the o9 workspace" },
        { src: `${DIR}/Industry_Collab/o9_4.webp`, tag: "Tech Immersion", caption: "Working shoulder-to-shoulder with o9" },
      ],
    },
  ],
};

/* ---- Project Week ---- */
export const projectWeek = {
  eyebrow: "Learning by building",
  title: "Project Week",
  text:
    "One intensive week. Students split into cross-branch teams, pick a real-world problem statement, and ship a working solution — from idea to demo — mentored every step of the way.",
  steps: [
    { n: "01", title: "Form Teams", text: "Cross-branch squads come together, mixing skills and perspectives." },
    { n: "02", title: "Identify a Problem", text: "Each team scopes a real-world problem statement worth solving." },
    { n: "03", title: "Build the Solution", text: "Design, build, and demo a working prototype within the week." },
  ],
  images: [
    `${DIR}/Projectweek/projectweek1.webp`,
    `${DIR}/Projectweek/projectweek2.webp`,
    `${DIR}/Projectweek/projectweek3.webp`,
    `${DIR}/Projectweek/projectweek4.webp`,
  ],
};

/* ---- Project Street ---- */
export const projectStreet = {
  eyebrow: "Showcasing innovation",
  title: "Project Street",
  text:
    "A campus-wide exhibition where student teams present their projects — on charts, posters, and live demos — to the entire college: faculty, peers, and visiting industry guests.",
  images: Array.from({ length: 9 }, (_, i) => `${DIR}/projectStreet/project-street-${i + 1}.webp`),
};

/* ---- Certifications + Claude-Certified Architects ---- */
export const certifications = {
  eyebrow: "AI-ready by design",
  title: "Certifications & Certified Architects",
  text:
    "NCET has 10 Claude-Certified Architects working closely with students every day — making them AI-ready for the careers of tomorrow. Alongside, students earn globally recognised industry certifications.",
  architectsImage: `${DIR}/claudeArchitects/architects-team.webp`,
  architectCount: 10,
  // EDIT: confirm the exact certification programs you offer
  certs: [
    "Claude (Anthropic) AI",
    "Google Cloud",
    "ServiceNow",
    "Snowflake",
    "MongoDB",
    "AWS Cloud",
    "Salesforce",
    "Microsoft Azure",
  ],
  gallery: [
    `${DIR}/Certifications/DSC_0655.webp`,
    `${DIR}/Certifications/DSC_0709.webp`,
    `${DIR}/Certifications/DSC_0728.webp`,
    `${DIR}/Certifications/DSC_0749.webp`,
    `${DIR}/Certifications/DSC_0756.webp`,
    `${DIR}/Certifications/DSC_0763.webp`,
  ],
};

/* ---- Placement Team (UI ready — replace with real members) ---- */
// EDIT: replace with the real placement team. `photo` can be a
// /images/placements-page/... path or left "" to show initials.
export const placementTeam = [
  { name: "Team Member", role: "Head — Training & Placements", photo: "" },
  { name: "Team Member", role: "Placement Officer", photo: "" },
  { name: "Team Member", role: "Corporate Relations", photo: "" },
  { name: "Team Member", role: "Training Coordinator", photo: "" },
  { name: "Team Member", role: "Industry Liaison", photo: "" },
  { name: "Team Member", role: "Placement Coordinator", photo: "" },
];
